import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SereneHeart } from "@/lib/brand";

export default function Login() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const F = "h-12 bg-[#FBF8F1] border-[#DCD1BC] text-[#2E2A22] placeholder:text-[#9C907A]";

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6" style={{ backgroundColor: "#F3EEE4" }} data-testid="login-screen">
      <form onSubmit={submit} className="w-full max-w-md space-y-5">
        <div className="text-center space-y-4 mb-2">
          <SereneHeart size={36} className="mx-auto" />
          <h2 className="font-serif text-2xl tracking-[0.2em] text-[#2E2A22]">MAISON ADMINISTRATION</h2>
        </div>
        <Input data-testid="login-email-input" required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={F} />
        <Input data-testid="login-password-input" required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={F} />
        {error && <p data-testid="login-error" className="text-xs tracking-[0.15em] text-[#A15B4B]">{error}</p>}
        <Button data-testid="login-submit-btn" type="submit" disabled={loading} className="w-full h-12 tracking-[0.2em] text-xs bg-[#2E2A22] text-[#F3EEE4] hover:bg-[#201C15]">
          {loading ? "SIGNING IN…" : "SIGN IN"}
        </Button>
        <button type="button" onClick={() => navigate("/")} className="w-full text-xs tracking-[0.2em] text-[#9C907A] hover:text-[#6B6151]">← BACK</button>
      </form>
    </div>
  );
}
